module.exports = __webpack_public_path__ + "img/logo.7a35ea5e.png";